import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class NotificationsService {
  changeActionedStatus = ({ id, isActioned }) => {
    return fetch(config.config.endpointUrls.changeActionedStatus({ id }), {
      method: 'PUT',
      body: { isActioned }
    })
  }
  fetchNotificationsForUser = (params) => {
    return fetch(config.config.endpointUrls.fetchNotificationsForUser(params), {
      method: 'GET'
    })
  }
}

export default new NotificationsService()



// WEBPACK FOOTER //
// ../src/services/notificationsService/notificationsService.js